module.exports = __webpack_public_path__ + "img/gf7sat.bb2e5e44.png";